import Vue from 'vue';
import $ from 'jquery';
import { mapGetters } from 'vuex';
import ObjectBrowser from 'src/components/project/create/ObjectBrowser.vue';
import ProgressIndicator from 'src/components/widgets/ProgressIndicator.vue';
import Progressbar from 'src/components/widgets/Progressbar.vue';
import Project from 'src/api/project';
import FormatUtils from 'src/utils/formatters';
export default Vue.extend({
    components: { ObjectBrowser, ProgressIndicator, Progressbar },
    data() {
        return {
            dataFile: null,
            objectPath: null,
            dropdowns: null,
            isLoading: false,
            isMounted: false,
            isFileSelected: false,
            noTextFieldError: false,
            step: 1
        };
    },
    computed: {
        ...mapGetters([
            'currentProject', 'currentSite', 'plan',
        ]),
        canGoBack() {
            return this.step > 1;
        },
        canGoNext() {
            return this.step > 1 || this.dataFile !== null;
        },
        numResponses() {
            if (this.dataFile) {
                return this.dataFile.records;
            }
            return 0;
        },
        projectId() {
            return this.$route.params.projectId;
        },
        // List of project text fields by name
        projectTextFields() {
            let textFields = [];
            this.currentProject.schema.forEach((f) => {
                if (f.type === 1) {
                    textFields.push(f.name);
                }
            });
            return textFields;
        },
        schema() {
            if (this.dataFile) {
                return this.dataFile.schema;
            }
            return [];
        },
        showDataUnits() {
            return this.plan === 'data-unit-plan';
        },
        integrationProvider() {
            return this.currentProject?.integration?.type;
        }
    },
    watch: {
        dataFile() {
            this.$nextTick(() => {
                this.dropdowns = $(this.$el).find('.mapping-table .ui.dropdown').dropdown();
                let schema = this.schema;
                this.dropdowns.each(function (i) {
                    $(this).dropdown('set selected', schema[i].name);
                });
            });
        }
    },
    mounted() {
        this.isMounted = true; // refs available
    },
    methods: {
        number: FormatUtils.number,
        // Check current mappings to determine if a text column is selected
        checkMappings() {
            let mappings = this.getMappings();
            let hasMappedText = false;
            for (let v of Object.values(mappings)) {
                if (v !== -1 && this.currentProject.schema[v].type === 1) {
                    hasMappedText = true;
                    break;
                }
            }
            return hasMappedText;
        },
        // Return list of current mappings.
        getMappings() {
            let mappings = {};
            this.dropdowns.each((i, el) => {
                mappings[this.schema[i].name] = parseInt($(el).dropdown('get value'), 10);
            });
            return mappings;
        },
        // Wait for s3/gcs import to be fully loaded
        pollImportStatus() {
            // Check if we have a schema, if not, set a timeout to recall this function
            if (['PROCESSING', 'AWAITING', 'UPLOADED'].includes(this.dataFile.status)) {
                Project.fetchFileStatus(this.dataFile.id)
                    .then((response) => {
                    this.dataFile = response;
                });
                this.dataFileTimeout = setTimeout(this.pollImportStatus, 2000);
            }
            else if (this.dataFile.schema !== null || this.dataFile.status === 'INDEXING') {
                clearTimeout(this.dataFileTimeout);
                this.dataFileTimeout = null;
                this.goNext();
                this.isLoading = false;
                this.$analytics.track.integration.exportData(false, this.integrationProvider, this.dataFile.records, this.dataFile.schema.length);
            }
        },
        // Initiate import of bucket object.
        runImport() {
            this.isLoading = true;
            if (this.integrationProvider === 's3') {
                return Project.createIntegrationExport('s3', { 's3ObjectPath': this.objectPath })
                    .then((response) => response.json())
                    .then((data) => {
                    this.dataFile = data;
                    // Initiate status check
                    this.pollImportStatus();
                });
            }
            else if (this.integrationProvider === 'gcs') {
                return Project.createIntegrationExport('gcs', { 'objectPath': this.objectPath })
                    .then((response) => response.json())
                    .then((data) => {
                    this.dataFile = data;
                    // Initiate status check
                    this.pollImportStatus();
                });
            }
        },
        // Trigger the indexing of data by the server.
        indexData() {
            this.isLoading = true;
            let dataFileId = this.dataFile.id;
            let mappings = this.getMappings();
            // Start indexing
            Project.indexDataFiles(this.projectId, [dataFileId], mappings).then(() => {
                this.$analytics.track.project.addData(this.dataFile.file_size, this.numResponses);
                this.$router.push({ name: 'project-details', params: { projectId: this.projectId } });
            }).finally(() => {
                this.isLoading = false;
            });
        },
        goBack() {
            this.noTextFieldError = false;
            if (this.step === 3) {
                this.step = 1;
            }
            else {
                this.step -= 1;
            }
        },
        goNext() {
            if (this.step === 3) {
                if (!this.checkMappings()) {
                    this.noTextFieldError = true;
                    return;
                }
                this.indexData();
                return;
            }
            this.noTextFieldError = false;
            this.step += 1;
        },
        onFileCleared() {
            this.dataFile = null;
            this.isFileSelected = false;
        },
        onFileReady(dataFile) {
            this.dataFile = dataFile;
        },
        onObjectSelected(path, size) {
            if (!path) {
                // After the data is uploaded and parsed, the user could opt out
                // of adding this data, and hit "back" instead. If this happens
                // the user goes back to the bucket file tree selection and may then
                // deselect the selected option. If that happens, the path will
                // be an empty string.
                return;
            }
            this.isFileSelected = true;
            // Strip off the "bucket" prefix
            this.objectPath = path.split('/').slice(1).join('/');
            // Short delay to give viewer a chance to see that the item got selected
            // and then move to the actual import.
            setTimeout(() => {
                this.goNext();
                this.runImport();
            }, 1000);
        }
    }
});
